import { computed, type ComputedRef, ref } from 'vue'

import { useVuetify } from '@/common/composables/libs/vuetify'
import type { Image } from '@/common/models/data/dashboard/media/image'

const useGalleryViewer = (entries: ComputedRef<Array<Image>>) => {
    const vuetify = useVuetify()

    const selectedImage = ref(-1)
    const showControls = ref(false)

    const currentImage = computed(() => entries.value[selectedImage.value])
    const showPreviousButton = computed(() => selectedImage.value > 0)
    const showNextButton = computed(() => selectedImage.value < entries.value.length - 1)
    const showModal = computed(() => selectedImage.value !== -1)

    // It may be not responsive to changes
    const maxDialogWidth = computed(() => {
        switch (vuetify.breakpoint.name) {
            case 'xl': return '30vw'
            case 'lg': return '35vw'
            case 'md': return '45vw'
            case 'sm': return '65vw'
            default: return '75vw'
        }
    })

    const selectImage = (index: number) => selectedImage.value = index

    return {
        currentImage,
        maxDialogWidth,
        selectedImage,
        showControls,
        showModal,
        showNextButton,
        showPreviousButton,
        selectImage
    }
}

export {
    useGalleryViewer
}
